import { DropdownMenu as DropdownMenuPrimitive } from 'radix-ui';
import { cn } from '../lib/utils.js';

export const DropdownMenu = DropdownMenuPrimitive.Root;
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
export const DropdownMenuGroup = DropdownMenuPrimitive.Group;

/** @param {import('react').ComponentProps<typeof DropdownMenuPrimitive.Content>} props */
export function DropdownMenuContent({ className, sideOffset = 4, ...props }) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        data-slot="dropdown-menu-content"
        sideOffset={sideOffset}
        className={cn('z-50 min-w-48 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-sm', className)}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  );
}

/**
 * @param {import('react').ComponentProps<typeof DropdownMenuPrimitive.Item> & { variant?: 'default'|'destructive', inset?: boolean }} props
 */
export function DropdownMenuItem({ className, variant = 'default', inset, ...props }) {
  return (
    <DropdownMenuPrimitive.Item
      data-slot="dropdown-menu-item"
      data-variant={variant}
      className={cn(
        'relative flex min-h-(--control-height-sm) cursor-default select-none items-center gap-2 rounded-sm px-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[variant=destructive]:text-destructive [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-muted-foreground',
        inset && 'pl-8',
        className,
      )}
      {...props}
    />
  );
}

/** @param {import('react').ComponentProps<typeof DropdownMenuPrimitive.Label>} props */
export function DropdownMenuLabel({ className, ...props }) {
  return <DropdownMenuPrimitive.Label data-slot="dropdown-menu-label" className={cn('px-2 py-1.5 text-sm font-medium', className)} {...props} />;
}

/** @param {import('react').ComponentProps<typeof DropdownMenuPrimitive.Separator>} props */
export function DropdownMenuSeparator({ className, ...props }) {
  return <DropdownMenuPrimitive.Separator data-slot="dropdown-menu-separator" className={cn('-mx-1 my-1 h-px bg-border', className)} {...props} />;
}
